var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Unknown Device Detected ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("p", [
              _vm._v(
                " We noticed you are logging in from an unknown device. An email has been sent to your address to verify your login attempt. Please check your email to proceed with logging in. "
              )
            ]),
            _c("p", [
              _vm._v(
                " You will not be able to login until this verification step is passed. Please "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "#"
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.openChat($event)
                    }
                  }
                },
                [_vm._v("contact our team")]
              ),
              _vm._v(" if you have any questions. ")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v(" Close ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }